import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface ISearchResultsStyles {
  root?: IStyle;
  header?: IStyle;
  list?: IStyle;
  description?: IStyle;
}

export interface ISearchResultsClassNames {
  root: string;
  header: string;
  list: string;
  description: string;
}

export const searchResultsStylesDefault = (theme: IH2OTheme): Partial<ISearchResultsStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  header: {},
  description: {
    color: theme.semanticColors?.textSecondary,
    marginTop: 8,
  },
  list: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
});
